import styled from 'styled-components'

import { mq, sizes } from '../../../theme'
import AdsCard from '../../AdsCard'

export const BlockAdsRelated = styled.div``

export const Title = styled.h2`
  ${({ theme }) => theme.textStyles.firaSans2XlBold};
  color: ${({ theme }) => theme.colors.bluePrimary};
  margin: 0 0 2rem 0;

  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.firaSans3XlBold};
  }
`

export const AdsRelatedList = styled.ul`
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  @media ${mq(sizes.tablet)} {
    display: grid;
    grid-template-columns: repeat(auto-fill, 30.5rem);
    grid-gap: 2.5rem;
  }

  @media ${mq(sizes.scoping)} {
    justify-content: space-between;
  }
`

export const AdsRelatedListItem = styled.li`
  @media ${mq(null, sizes.tablet)} {
    .AdsCard {
      width: 100%;
    }
  }
`

export const Card = styled(AdsCard)`
  width: 30.5rem;
  height: 100%;
`
